import { Table } from 'react-bootstrap';
import React from 'react';

import { fixDecimals, minsToTime } from '../../../helpers';
import './DataPerformanceTab.scss';
import { CUSTOM_ZONE_METRICS, RELATIVE_METRICS } from '../../../config/constants';
import { DataPerformanceProps } from './types';

const DataPerformanceTab = ({ flag, playerData, selectedZoneType }: DataPerformanceProps) => {
  const relative = (selectedZoneType === 'Player') ? 1 : 0;
  if (!flag) {
    return <Table responsive>
      {/* <thead>
       <div className="title-p">
       <div className="title-p">DIS/TIME/SPRINTS BY TEAM ZONE</div>
       </div>
       <tr>
       <th width="50%">METRIC TITLE</th>
       <th width="50%" className="l-c">RESULT</th>
       </tr>
       </thead>
       <tbody>
       <tr>
       <td>Total Distance</td>
       <td className="l-c">{playerData.totalDis} <span className="uv-l">-</span></td>
       </tr>
       <tr>
       <td>Team Target MPH</td>
       <td className="l-c">{relative ? playerData.metrics.targetMPHRelative : playerData.metrics.targetMPH} <span className="uv-l">-</span></td>
       </tr>
       <tr>
       <td>Team Walk Yards</td>
       <td className="l-c">{playerData.walkYds} <span className="uv-l">-</span></td>
       </tr>
       <tr>
       <td>Team Jog Yards</td>
       <td className="l-c">{playerData.jogYds} <span className="uv-l">-</span></td>
       </tr>
       <tr>
       <td>Team Run Yards</td>
       <td className="l-c">{playerData.runYds} <span className="uv-l">-</span></td>
       </tr>
       <tr>
       <td>Team Sprint Yards</td>
       <td className="l-c">{playerData.sprintYds} <span className="uv-l">-</span></td>
       </tr>
       <tr>
       <td>Team Max Sprint Yards</td>
       <td className="l-c">{playerData.maxSprintYds} <span className="uv-l">-</span></td>
       </tr>
       <tr>
       <td>Yards at 10+ MPH</td>
       <td className="l-c">-- <span className="uv-l">-</span></td>
       </tr>
       </tbody> */}
      
      
      {selectedZoneType === 'Team' ? (
        <thead>
        <tr>
          <th style={{ width: '50%' }}>
            <div className='data-subtitle'>TEAM ZONE</div>
            <br />METRIC TITLE
          </th>
          <th style={{ width: '50%' }} className="l-c">RESULT</th>
        </tr>
        </thead>
      ) : 
      selectedZoneType === 'Custom' ?(
         <thead>
        <tr>
          <th style={{ width: '50%' }}>
            <div className='data-subtitle'>CUSTOM ZONE</div>
            <br />METRIC TITLE
          </th>
          <th style={{ width: '50%' }} className="l-c">RESULT</th>
        </tr>
        </thead>
      ):
      (
        <thead>
        <tr>
          <th style={{ width: '50%' }}>
            <div className='data-subtitle'>PLAYER RELATIVE ZONE</div>
            <br />METRIC TITLE
          </th>
          <th style={{ width: '50%' }} className="l-c">RESULT</th>
        </tr>
        </thead>
      )}
      
      <tbody>
      {selectedZoneType === 'Team' ? (<>
          <tr>
            <td>Time Tracked</td>
            <td className="l-c">{minsToTime(playerData.metrics.timeMoving)}</td>
          </tr>
          <tr>
            <td>Total Distance</td>
            <td className="l-c">{fixDecimals(playerData.metrics.totalDis, 0)} {/*<span className="uv-l">-</span>*/}</td>
          </tr>
          <tr>
            <td>Team Target MPH</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.targetMPHRelative : playerData.metrics.targetMPH, 1)}</td>
          </tr>
          <tr>
            <td>Team Walk Yards</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.walkYdsRelative : playerData.metrics.walkYds, 0)}</td>
          </tr>
          <tr>
            <td>Team Jog Yards</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.jogYdsRelative : playerData.metrics.jogYds, 0)}</td>
          </tr>
          <tr>
            <td>Team Run Yards</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.runYdsRelative : playerData.metrics.runYds, 0)} </td>
          </tr>
          <tr>
            <td>Team Sprint Yards</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.sprintYdsRelative : playerData.metrics.sprintYds, 0)} </td>
          </tr>
          <tr>
            <td>Team Max Sprint Yards</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.maxSprintYdsRelative : playerData.metrics.maxSprintYds, 0)} </td>
          </tr>
          <tr>
            <td>Yards at {playerData.teamId === '1050' ? '12' : '10'}+ MPH</td>
            <td className="l-c">{fixDecimals(playerData.metrics.dist10Plus, 0)}</td>
          </tr>
          <tr>
            <td>Team Walk Time</td>
            <td
              className="l-c">{minsToTime(relative ? playerData.metrics.walkTimeRelative : playerData.metrics.walkTime)}</td>
          </tr>
          <tr>
            <td>Team Jog Time</td>
            <td
              className="l-c">{minsToTime(relative ? playerData.metrics.jogTimeRelative : playerData.metrics.jogTime)}</td>
          </tr>
          <tr>
            <td>Team Run Time</td>
            <td
              className="l-c">{minsToTime(relative ? playerData.metrics.runTimeRelative : playerData.metrics.runTime)}</td>
          </tr>
          <tr>
            <td>Team Sprint Time</td>
            <td
              className="l-c">{minsToTime(relative ? playerData.metrics.sprintTimeRelative : playerData.metrics.sprintTime)}</td>
          </tr>
          <tr>
            <td>Team Max Sprint Time</td>
            <td
              className="l-c">{minsToTime(relative ? playerData.metrics.maxSprintTimeRelative : playerData.metrics.maxSprintTime)}</td>
          </tr>
          <tr>
            <td>Time at {playerData.teamId === '1050' ? '12' : '10'}+ MPH</td>
            <td className="l-c">{minsToTime(playerData.metrics.time10Plus)}</td>
          </tr>
          <tr>
            <td>Team Hard Efford Distance</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.hardEffortDistRelative : playerData.metrics.hardEffortDist, 0)}{/*<span
             className="uv-l">-</span>*/}</td>
          </tr>
          <tr>
            <td>Team Sprint Count</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.sprintCountRelative : playerData.metrics.sprintCount, 0)}</td>
          </tr>
          <tr>
            <td>Team Max Sprint Count</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.maxSprintCountRelative : playerData.metrics.maxSprintCount, 0)}</td>
          </tr>
        </>
      ) : 
      selectedZoneType === 'Custom'?
      (
        <>
         <tr>
            <td>Time Tracked</td>
            <td className="l-c">{minsToTime(playerData.metrics.timeMoving)}</td>
          </tr>
          <tr>
            <td>Total Distance</td>
            <td className="l-c">{fixDecimals(playerData.metrics.totalDis, 0)} {/*<span className="uv-l">-</span>*/}</td>
          </tr>
          <tr>
            <td>Custom Target MPH</td>
            <td
              className="l-c">{fixDecimals(playerData.metrics.targetMPHCustom, 1)}</td>
          </tr>
          <tr>
            <td>Custom Walk Yards</td>
            <td
              className="l-c">{fixDecimals(playerData.metrics.walkYdsCustom, 0)}</td>
          </tr>
          <tr>
            <td>Custom Jog Yards</td>
            <td
              className="l-c">{fixDecimals(playerData.metrics.jogYdsCustom, 0)}</td>
          </tr>
          <tr>
            <td>Custom Run Yards</td>
            <td
              className="l-c">{fixDecimals(playerData.metrics.runYdsCustom, 0)} </td>
          </tr>
          <tr>
            <td>Custom Sprint Yards</td>
            <td
              className="l-c">{fixDecimals(playerData.metrics.sprintYdsCustom, 0)} </td>
          </tr>
          <tr>
            <td>Custom Max Sprint Yards</td>
            <td
              className="l-c">{fixDecimals(playerData.metrics.maxSprintYdsCustom, 0)} </td>
          </tr>
          <tr>
            <td>Custom Walk Time</td>
            <td
              className="l-c">{minsToTime(playerData.metrics.walkTimeCustom)}</td>
          </tr>
          <tr>
            <td>Custom Jog Time</td>
            <td
              className="l-c">{minsToTime(playerData.metrics.jogTimeCustom)}</td>
          </tr>
          <tr>
            <td>Custom Run Time</td>
            <td
              className="l-c">{minsToTime(playerData.metrics.runTimeCustom)}</td>
          </tr>
          <tr>
            <td>Custom Sprint Time</td>
            <td
              className="l-c">{minsToTime(playerData.metrics.sprintTimeCustom)}</td>
          </tr>
          <tr>
            <td>Custom Max Sprint Time</td>
            <td
              className="l-c">{minsToTime(playerData.metrics.maxSprintTimeCustom)}</td>
          </tr>
          <tr>
            <td>Custom Hard Efford Distance</td>
            <td
              className="l-c">{fixDecimals(playerData.metrics.hardEffortDistCustom, 0)}{/*<span
             className="uv-l">-</span>*/}</td>
          </tr>
          <tr>
            <td>Custom Sprint Count</td>
            <td
              className="l-c">{fixDecimals(playerData.metrics.sprintCountCustom, 0)}</td>
          </tr>
          <tr>
            <td>Custom Max Sprint Count</td>
            <td
              className="l-c">{fixDecimals(playerData.metrics.maxSprintCountCustom, 0)}</td>
          </tr>
        </>
      )
      :
      (<>
          <tr>
            <td>Time Tracked</td>
            <td className="l-c">{minsToTime(playerData.metrics.timeMoving)} </td>
          </tr>
          <tr>
            <td>Total Distance</td>
            <td className="l-c">{fixDecimals(playerData.metrics.totalDis, 0)} {/*<span className="uv-l">-</span>*/}</td>
          </tr>
          <tr>
            <td>Relative Target MPH</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.targetMPHRelative : playerData.metrics.targetMPH, 1)}</td>
          </tr>
          <tr>
            <td>Relative Walk Yards</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.walkYdsRelative : playerData.metrics.walkYds, 0)}</td>
          </tr>
          <tr>
            <td>Relative Jog Yards</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.jogYdsRelative : playerData.metrics.jogYds, 0)}</td>
          </tr>
          <tr>
            <td>Relative Run Yards</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.runYdsRelative : playerData.metrics.runYds, 0)}</td>
          </tr>
          <tr>
            <td>Relative Sprint Yards</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.sprintYdsRelative : playerData.metrics.sprintYds, 0)}</td>
          </tr>
          <tr>
            <td>Relative Max Sprint Yards</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.maxSprintYdsRelative : playerData.metrics.maxSprintYds, 0)}</td>
          </tr>
          <tr>
            <td>Relative Walk Time</td>
            <td
              className="l-c">{minsToTime(relative ? playerData.metrics.walkTimeRelative : playerData.metrics.walkTime)}</td>
          </tr>
          <tr>
            <td>Relative Jog Time</td>
            <td
              className="l-c">{minsToTime(relative ? playerData.metrics.jogTimeRelative : playerData.metrics.jogTime)}</td>
          </tr>
          <tr>
            <td>Relative Run Time</td>
            <td
              className="l-c">{minsToTime(relative ? playerData.metrics.runTimeRelative : playerData.metrics.runTime)}</td>
          </tr>
          <tr>
            <td>Relative Sprint Time</td>
            <td
              className="l-c">{minsToTime(relative ? playerData.metrics.sprintTimeRelative : playerData.metrics.sprintTime)}</td>
          </tr>
          <tr>
            <td>Relative Max Sprint Time</td>
            <td
              className="l-c">{minsToTime(relative ? playerData.metrics.maxSprintTimeRelative : playerData.metrics.maxSprintTime)}</td>
          </tr>
          <tr>
            <td>Relative Hard Effort Distance</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.hardEffortDistRelative : playerData.metrics.hardEffortDist, 0)}{/*<span
             className="uv-l">-</span>*/}</td>
          </tr>
          <tr>
            <td>Relative Sprint Count</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.sprintCountRelative : playerData.metrics.sprintCount, 0)}</td>
          </tr>
          <tr>
            <td>Relative Max Sprint Count</td>
            <td
              className="l-c">{relative ? playerData.metrics.maxSprintCountRelative : playerData.metrics.maxSprintCount}</td>
          </tr>
        </>
      )}
      
      <br />
      
      <tr>
        <th style={{ width: '50%' }}>
          <div className='data-subtitle'>TIMING AND PACE</div>
          <br />METRIC TITLE
        </th>
        <th style={{ width: '50%' }} className="l-c">RESULT</th>
      </tr>
      <tr>
        <td>Time Tracked</td>
        <td className="l-c">{minsToTime(playerData.metrics.timeTrkd)}</td>
      </tr>
      <tr>
        <td>Time Moving</td>
        <td className="l-c">{minsToTime(playerData.metrics.timeMoving)}</td>
      </tr>
      <tr>
        <td>Yards/Minute</td>
        <td className="l-c">{fixDecimals(playerData.metrics.ypm, 1)}</td>
      </tr>
      <tr>
        <td>Average Active Speed (YPS)</td>
        <td className="l-c">{fixDecimals(relative ? playerData.metrics.actYPSRel : playerData.metrics.actYPS, 1)}</td>
      </tr>
      <tr>
        <td>Average Active Speed (MPH)</td>
        <td className="l-c">{fixDecimals(relative ? playerData.metrics.actMPHRel : playerData.metrics.actMPH, 1)}</td>
      </tr>
      <tr>
        <td>Accelerations/Minute</td>
        <td className="l-c">{fixDecimals(playerData.metrics.accelPerMin, 2)}</td>
      </tr>
      <tr>
        <td>Decelerations/Minute</td>
        <td className="l-c">{fixDecimals(playerData.metrics.deccelPerMin, 2)}</td>
      </tr>
      <tr>
        <td>Max Speed YPS</td>
        <td className="l-c">{fixDecimals(playerData.metrics.maxSpeedYPS, 2)}</td>
      </tr>
      <tr>
        <td>Max Speed MPH</td>
        <td className="l-c">{fixDecimals(playerData.metrics.maxSpeedMPH, 2)}{/*<span className="uv-l">-</span>*/}</td>
      </tr>
      <tr>
        <td>Explosive Effort</td>
        <td className="l-c">{fixDecimals(playerData.metrics.accelFast + playerData.metrics.deccelFast, 0)}</td>
      </tr>
      <tr>
        <td>Max Sustained Speed (YPS)</td>
        <td className="l-c">{fixDecimals(playerData.metrics.maxSustainedSpeedYPS, 2)}</td>
      </tr>
      <tr>
        <td>Max Sustained Speed (MPH)</td>
        <td
          className="l-c">{fixDecimals(playerData.metrics.maxSustainedSpeedMPH, 2)}{/*<span className="uv-l">-</span>*/}
        </td>
      </tr>
      <br />
      <tr>
        <th style={{ width: '50%' }}>
          <div className='data-subtitle'>ACCELS AND DECELS</div>
          <br />METRIC TITLE
        </th>
        <th style={{ width: '50%' }} className="l-c">RESULT</th>
      </tr>
      <tr>
        <td>Time Tracked</td>
        <td className="l-c">{minsToTime(playerData.metrics.timeTrkd)}</td>
      </tr>
      <tr>
        <td>Time Moving</td>
        <td className="l-c">{minsToTime(playerData.metrics.timeMoving)}</td>
      </tr>
      <tr>
        <td>Total Accelerations</td>
        <td
          className="l-c">{fixDecimals(playerData.metrics.accelSlow + playerData.metrics.accelMed + playerData.metrics.accelFast, 0)}</td>
      </tr>
      <tr>
        <td>Low Acceleration Count</td>
        <td className="l-c">{fixDecimals(playerData.metrics.accelSlow, 0)}</td>
      </tr>
      <tr>
        <td>Medium Acceleration Count</td>
        <td className="l-c">{fixDecimals(playerData.metrics.accelMed, 0)}</td>
      </tr>
      <tr>
        <td>High Acceleration Count</td>
        <td className="l-c">{fixDecimals(playerData.metrics.accelFast, 0)}</td>
      </tr>
      <tr>
        <td>Distance in Low Acceleration</td>
        <td className="l-c">{fixDecimals(playerData.metrics.accelDistSlow, 0)}</td>
      </tr>
      <tr>
        <td>Distance in Medium Acceleration</td>
        <td className="l-c">{fixDecimals(playerData.metrics.accelDistMed, 0)}</td>
      </tr>
      <tr>
        <td>Distance in High Acceleration</td>
        <td className="l-c">{fixDecimals(playerData.metrics.accelDistFast, 0)}</td>
      </tr>
      <tr>
        <td>Total Deceleration Counts</td>
        <td
          className="l-c">{fixDecimals(playerData.metrics.deccelSlow + playerData.metrics.deccelMed + playerData.metrics.deccelFast, 0)}</td>
      </tr>
      <tr>
        <td>Low Deceleration Counts</td>
        <td className="l-c">{fixDecimals(playerData.metrics.deccelSlow, 0)}</td>
      </tr>
      <tr>
        <td>Medium Deceleration Counts</td>
        <td className="l-c">{fixDecimals(playerData.metrics.deccelMed, 0)}</td>
      </tr>
      <tr>
        <td>High Deceleration counts</td>
        <td className="l-c">{fixDecimals(playerData.metrics.deccelFast, 0)}</td>
      </tr>
      <tr>
        <td>Distance in Low Deceleration</td>
        <td className="l-c">{fixDecimals(playerData.metrics.deccelDistSlow, 0)}</td>
      </tr>
      <tr>
        <td>Distance in Medium deceleration</td>
        <td className="l-c">{fixDecimals(playerData.metrics.deccelDistMed, 0)}</td>
      </tr>
      <tr>
        <td>Distance in High Deceleration</td>
        <td className="l-c">{fixDecimals(playerData.metrics.deccelDistFast, 0)}</td>
      </tr>
      <tr>
        <td>Exertion Index</td>
        <td className="l-c">{fixDecimals(playerData.metrics.exIndex, 2)}</td>
      </tr>
      <tr>
        <td>Player Load</td>
        <td className="l-c">{fixDecimals(playerData.metrics.zLoad, 2)}</td>
      </tr>
      <tr>
        <td>Max Acceleration</td>
        <td className="l-c">{fixDecimals(playerData.metrics.maxAccel, 2)}</td>
      </tr>
      <tr>
        <td>Max Sustained Acceleration</td>
        <td className="l-c">{fixDecimals(playerData.metrics.maxSustAccel, 2)}</td>
      </tr>
      <tr>
        <td>Max Deceleration</td>
        <td className="l-c">{fixDecimals(playerData.metrics.maxDecel, 2)}</td>
      </tr>
      <tr>
        <td>Max Sustained Deceleration</td>
        <td className="l-c">{fixDecimals(playerData.metrics.maxSustDecel, 2)}</td>
      </tr>
      </tbody>
    </Table>;
  } else { // comes from live metrics!!! (flag === true)
    return <Table responsive>
      {selectedZoneType === 'Team' ? (
        <thead>
        <tr>
          <th style={{ width: '50%' }}>
            <div className='data-subtitle'>SPEED</div>
            <br /> METRIC TITLE
          </th>
          <th style={{ width: '50%' }} className="l-c">RESULT</th>
        </tr>
        </thead>
      ) : (
        <thead>
        <tr>
          <th style={{ width: '50%' }}>
            <div className='data-subtitle'>SPEED</div>
            <br /> METRIC TITLE
          </th>
          <th style={{ width: '50%' }} className="l-c">RESULT</th>
        </tr>
        </thead>
      )}
      
      <tbody>
      {selectedZoneType === 'Team' ? (<>
          <tr>
            <td>Team Target Speed</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.targetMPHRelative : playerData.metrics.targetMPH, 1)}
            </td>
          </tr>
          <tr>
            <td>Max Speed</td>
            <td className="l-c">{fixDecimals(playerData.metrics.maxSpeedMPH, 2)}
              <label
                style={{ marginLeft: '.5rem' }}>{' '}{Number.isInteger(+fixDecimals((relative ? playerData.metrics['maxSpeedMPHAs%ofTarget_Relative'] : 
                  playerData.metrics['maxSpeedMPHAs%ofTarget']) * 100, 0)) ?
                `(${fixDecimals((relative ? playerData.metrics['maxSpeedMPHAs%ofTarget_Relative'] : playerData.metrics['maxSpeedMPHAs%ofTarget']) * 100, 0)}%)` :
                ' -'}</label></td>
          </tr>
          <tr>
            <td>Max Sustained Speed</td>
            <td className="l-c">{fixDecimals(playerData.metrics.maxSustainedSpeedMPH, 2)}
              <label
                style={{ marginLeft: '.5rem' }}>{' '}{Number.isInteger(+fixDecimals((relative ? playerData.metrics['maxSustSpeedMPHAs%ofTarget_Relative'] : 
                  playerData.metrics['maxSustSpeedMPHAs%ofTarget']) * 100, 0)) ?
                `(${fixDecimals((relative ? playerData.metrics['maxSustSpeedMPHAs%ofTarget_Relative'] : playerData.metrics['maxSustSpeedMPHAs%ofTarget']) * 100, 0)}%)` :
                ' -'}</label></td>
          </tr>
          <tr>
            <td>Time Since X% of Max</td>
            <td className="l-c">{'00:00:00'} </td>
          </tr>
          <br />
          <tr>
            <th style={{ width: '50%' }}>
              <div className='data-subtitle'>DISTANCES</div>
              <br /> METRIC TITLE
            </th>
            <th style={{ width: '50%' }} className="l-c">RESULT</th>
          </tr>
          <tr>
            <td>Total Distance</td>
            <td className="l-c">{fixDecimals(playerData.metrics.totalDis, 0) + ' '}
              {<span className="uv-l">
                  {Number.isInteger(+fixDecimals(playerData.metrics['historyTotalDistance_%'] * 100, 0)) ?
                    ` (${fixDecimals(playerData.metrics['historyTotalDistance_%'] * 100, 0)}%)` :
                    ' -'}
                </span>}
            </td>
          </tr>
          <tr>
            <td>Team Hard Efford Distance</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.hardEffortDistRelative : playerData.metrics.hardEffortDist, 0)}
              {<span className="uv-l">
                {Number.isInteger(+fixDecimals((relative ? playerData.metrics[RELATIVE_METRICS['historyHardEffortDistance_%']] :
                  playerData.metrics['historyHardEffortDistance_%']) * 100, 0)) &&
                  +fixDecimals(playerData.metrics['historyHardEffortDistance_%'] * 100, 0)  >=0 ?
                  ` (${fixDecimals((relative ? playerData.metrics[RELATIVE_METRICS['historyHardEffortDistance_%']] :
                    playerData.metrics['historyHardEffortDistance_%']) * 100, 0)}%)` : ' -'}
                </span>}
            </td>
          </tr>
          <tr>
            <td>Team Walk Yards</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.walkYdsRelative : playerData.metrics.walkYds, 0)} </td>
          </tr>
          <tr>
            <td>Team Jog Yards</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.jogYdsRelative : playerData.metrics.jogYds, 0)} </td>
          </tr>
          <tr>
            <td>Team Run Yards</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.runYdsRelative : playerData.metrics.runYds, 0)} </td>
          </tr>
          <tr>
            <td>Team Sprint Yards</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.sprintYdsRelative : playerData.metrics.sprintYds, 0)} </td>
          </tr>
          <tr>
            <td>Team Max Sprint Yards</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.maxSprintYdsRelative : playerData.metrics.maxSprintYds, 0)} </td>
          </tr>
          <br />
          <tr>
            <th style={{ width: '50%' }}>
              <div className='data-subtitle'>ACCEL COUNTS</div>
              <br /> METRIC TITLE
            </th>
            <th style={{ width: '50%' }} className="l-c">RESULT</th>
          </tr>
          
          <tr>
            <td>Low Acceleration Count</td>
            <td className="l-c">{fixDecimals(playerData.metrics.accelSlow, 0)}</td>
          </tr>
          <tr>
            <td>Medium Acceleration Count</td>
            <td className="l-c">{fixDecimals(playerData.metrics.accelMed, 0)}</td>
          </tr>
          <tr>
            <td>High Acceleration Count</td>
            <td className="l-c">{fixDecimals(playerData.metrics.accelFast, 0)}</td>
          </tr>
          
          <br />
          <tr>
            <th style={{ width: '50%' }}>
              <div className='data-subtitle'>DECEL COUNTS</div>
              <br /> METRIC TITLE
            </th>
            <th style={{ width: '50%' }} className="l-c">RESULT</th>
          </tr>
          <tr>
            <td>Low Deceleration Counts</td>
            <td className="l-c">{fixDecimals(playerData.metrics.deccelSlow, 0)}</td>
          </tr>
          <tr>
            <td>Medium Deceleration Counts</td>
            <td className="l-c">{fixDecimals(playerData.metrics.deccelMed, 0)}</td>
          </tr>
          <tr>
            <td>High Deceleration counts</td>
            <td className="l-c">{fixDecimals(playerData.metrics.deccelFast, 0)}</td>
          </tr>
        </>
      ) : 
      selectedZoneType === 'Custom'?
      (
        <>
          <tr>
            <td>Custom Target Speed</td>
            <td
              className="l-c">{fixDecimals( playerData.metrics.targetMPHCustom, 1)} </td>
          </tr>
          <tr>
            <td>Max Speed</td>
            <td className="l-c">{fixDecimals(playerData.metrics.maxSpeedMPH, 2)}
              <label
                style={{ marginLeft: '.2rem' }}>{Number.isInteger(+fixDecimals((playerData.metrics['maxSpeedMPHAs%ofTarget_Custom']) * 100, 0)) ?
                ` (${fixDecimals((playerData.metrics['maxSpeedMPHAs%ofTarget_Custom']) * 100, 0)}%)` :
                '-'}</label></td>
          </tr>
          <tr>
            <td>Max Sustained Speed</td>
            <td className="l-c">{fixDecimals(playerData.metrics.maxSustainedSpeedMPH, 2)}
              <label
                style={{ marginLeft: '.2rem' }}>{Number.isInteger(+fixDecimals((playerData.metrics['maxSustSpeedMPHAs%ofTarget_Custom']) * 100, 0)) ?
                ` (${fixDecimals((playerData.metrics['maxSustSpeedMPHAs%ofTarget_Custom']) * 100, 0)}%)` :
                '-'}</label></td>
          </tr>
          <tr>
            <td>Time Since X% of Max</td>
            <td className="l-c">{'00:00:00'} </td>
          </tr>
          <br />
          
          
          <tr>
            <th style={{ width: '50%' }}>
              <div className='data-subtitle'>DISTANCES</div>
              <br />METRIC TITLE
            </th>
            <th style={{ width: '50%' }} className="l-c">RESULT</th>
          </tr>
          <tr>
            <td>Total Distance</td>
            <td className="l-c">{fixDecimals(playerData.metrics.totalDis, 0) + ' '}
              {<span className="uv-l">
                  {Number.isInteger(+fixDecimals(playerData.metrics['historyTotalDistance_%'] * 100, 0)) ?
                    ` (${fixDecimals(playerData.metrics['historyTotalDistance_%'] * 100, 0)}%)` :
                    '-'}
                </span>}
            </td>
          </tr>
          <tr>
            <td>Custom Hard Efford Distance</td>
            <td
              className="l-c">{fixDecimals(playerData.metrics.hardEffortDistCustom, 0) + ' '}
              {<span className="uv-l">
                {Number.isInteger(+fixDecimals((playerData.metrics[CUSTOM_ZONE_METRICS['historyHardEffortDistance_%']]) * 100, 0)) &&
                  +fixDecimals(playerData.metrics['historyHardEffortDistanceCustom_%'] * 100, 0)  >=0 ?
                    ` (${fixDecimals((playerData.metrics[CUSTOM_ZONE_METRICS['historyHardEffortDistance_%']]) * 100, 0)}%)` : '-'}
                </span>}
            </td>
          </tr>
          <tr>
            <td>Custom Walk Yards</td>
            <td
              className="l-c">{fixDecimals(playerData.metrics.walkYdsCustom, 0)} </td>
          </tr>
          <tr>
            <td>Custom Jog Yards</td>
            <td
              className="l-c">{fixDecimals(playerData.metrics.jogYdsCustom, 0)} </td>
          </tr>
          <tr>
            <td>Custom Run Yards</td>
            <td
              className="l-c">{fixDecimals(playerData.metrics.runYdsCustom, 0)} </td>
          </tr>
          <tr>
            <td>Custom Sprint Yards</td>
            <td
              className="l-c">{fixDecimals(playerData.metrics.sprintYdsCustom , 0)} </td>
          </tr>
          <tr>
            <td>Custom Max Sprint Yards</td>
            <td
              className="l-c">{fixDecimals(playerData.metrics.maxSprintYdsCustom, 0)} </td>
          </tr>
          <br />
          <tr>
            <th style={{ width: '50%' }}>
              <div className='data-subtitle'>ACCEL COUNTS</div>
              <br />METRIC TITLE
            </th>
            <th style={{ width: '50%' }} className="l-c">RESULT</th>
          </tr>
          <tr>
            <td>Low Acceleration Count</td>
            <td className="l-c">{fixDecimals(playerData.metrics.accelSlow, 0)}</td>
          </tr>
          <tr>
            <td>Medium Acceleration Count</td>
            <td className="l-c">{fixDecimals(playerData.metrics.accelMed, 0)}</td>
          </tr>
          <tr>
            <td>High Acceleration Count</td>
            <td className="l-c">{fixDecimals(playerData.metrics.accelFast, 0)}</td>
          </tr>
          <br />
          <tr>
            <th style={{ width: '50%' }}>
              <div className='data-subtitle'>DECEL COUNTS</div>
              <br />METRIC TITLE
            </th>
            <th style={{ width: '50%' }} className="l-c">RESULT</th>
          </tr>
          <tr>
            <td>Low Deceleration Counts</td>
            <td className="l-c">{fixDecimals(playerData.metrics.deccelSlow, 0)}</td>
          </tr>
          <tr>
            <td>Medium Deceleration Counts</td>
            <td className="l-c">{fixDecimals(playerData.metrics.deccelMed, 0)}</td>
          </tr>
          <tr>
            <td>High Deceleration counts</td>
            <td className="l-c">{fixDecimals(playerData.metrics.deccelFast, 0)}</td>
          </tr>
        </>
      ):
      (<>
          <tr>
            <td>Relative Target Speed</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.targetMPHRelative : playerData.metrics.targetMPH, 1)} </td>
          </tr>
          <tr>
            <td>Max Speed</td>
            <td className="l-c">{fixDecimals(playerData.metrics.maxSpeedMPH, 2)}
              <label
                style={{ marginLeft: '.2rem' }}>{Number.isInteger(+fixDecimals((relative ? playerData.metrics['maxSpeedMPHAs%ofTarget_Relative'] : 
                  playerData.metrics['maxSpeedMPHAs%ofTarget']) * 100, 0)) ?
                ` (${fixDecimals((relative ? playerData.metrics['maxSpeedMPHAs%ofTarget_Relative'] : playerData.metrics['maxSpeedMPHAs%ofTarget']) * 100, 0)}%)` :
                '-'}</label></td>
          </tr>
          <tr>
            <td>Max Sustained Speed</td>
            <td className="l-c">{fixDecimals(playerData.metrics.maxSustainedSpeedMPH, 2)}
              <label
                style={{ marginLeft: '.2rem' }}>{Number.isInteger(+fixDecimals((relative ? playerData.metrics['maxSustSpeedMPHAs%ofTarget_Relative'] : 
                  playerData.metrics['maxSustSpeedMPHAs%ofTarget']) * 100, 0)) ?
                ` (${fixDecimals((relative ? playerData.metrics['maxSustSpeedMPHAs%ofTarget_Relative'] : playerData.metrics['maxSustSpeedMPHAs%ofTarget']) * 100, 0)}%)` :
                '-'}</label></td>
          </tr>
          <tr>
            <td>Time Since X% of Max</td>
            <td className="l-c">{'00:00:00'} </td>
          </tr>
          <br />
          
          
          <tr>
            <th style={{ width: '50%' }}>
              <div className='data-subtitle'>DISTANCES</div>
              <br />METRIC TITLE
            </th>
            <th style={{ width: '50%' }} className="l-c">RESULT</th>
          </tr>
          <tr>
            <td>Total Distance</td>
            <td className="l-c">{fixDecimals(playerData.metrics.totalDis, 0) + ' '}
              {<span className="uv-l">
                  {Number.isInteger(+fixDecimals(playerData.metrics['historyTotalDistance_%'] * 100, 0)) ?
                    ` (${fixDecimals(playerData.metrics['historyTotalDistance_%'] * 100, 0)}%)` :
                    '-'}
                </span>}
            </td>
          </tr>
          <tr>
            <td>Relative Hard Efford Distance</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.hardEffortDistRelative : playerData.metrics.hardEffortDist, 0) + ' '}
              {<span className="uv-l">
                {Number.isInteger(+fixDecimals((relative ? playerData.metrics[RELATIVE_METRICS['historyHardEffortDistance_%']] :
                  playerData.metrics['historyHardEffortDistance_%']) * 100, 0)) &&
                  +fixDecimals(playerData.metrics['historyHardEffortDistanceRelative_%'] * 100, 0)  >=0 ?
                    ` (${fixDecimals((relative ? playerData.metrics[RELATIVE_METRICS['historyHardEffortDistance_%']] :
                    playerData.metrics['historyHardEffortDistance_%']) * 100, 0)}%)` : '-'}
                </span>}
            </td>
          </tr>
          <tr>
            <td>Relative Walk Yards</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.walkYdsRelative : playerData.metrics.walkYds, 0)} </td>
          </tr>
          <tr>
            <td>Relative Jog Yards</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.jogYdsRelative : playerData.metrics.jogYds, 0)} </td>
          </tr>
          <tr>
            <td>Relative Run Yards</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.runYdsRelative : playerData.metrics.runYds, 0)} </td>
          </tr>
          <tr>
            <td>Relative Sprint Yards</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.sprintYdsRelative : playerData.metricssprintYds, 0)} </td>
          </tr>
          <tr>
            <td>Relative Max Sprint Yards</td>
            <td
              className="l-c">{fixDecimals(relative ? playerData.metrics.maxSprintYdsRelative : playerData.metrics.maxSprintYds, 0)} </td>
          </tr>
          <br />
          <tr>
            <th style={{ width: '50%' }}>
              <div className='data-subtitle'>ACCEL COUNTS</div>
              <br />METRIC TITLE
            </th>
            <th style={{ width: '50%' }} className="l-c">RESULT</th>
          </tr>
          <tr>
            <td>Low Acceleration Count</td>
            <td className="l-c">{fixDecimals(playerData.metrics.accelSlow, 0)}</td>
          </tr>
          <tr>
            <td>Medium Acceleration Count</td>
            <td className="l-c">{fixDecimals(playerData.metrics.accelMed, 0)}</td>
          </tr>
          <tr>
            <td>High Acceleration Count</td>
            <td className="l-c">{fixDecimals(playerData.metrics.accelFast, 0)}</td>
          </tr>
          <br />
          <tr>
            <th style={{ width: '50%' }}>
              <div className='data-subtitle'>DECEL COUNTS</div>
              <br />METRIC TITLE
            </th>
            <th style={{ width: '50%' }} className="l-c">RESULT</th>
          </tr>
          <tr>
            <td>Low Deceleration Counts</td>
            <td className="l-c">{fixDecimals(playerData.metrics.deccelSlow, 0)}</td>
          </tr>
          <tr>
            <td>Medium Deceleration Counts</td>
            <td className="l-c">{fixDecimals(playerData.metrics.deccelMed, 0)}</td>
          </tr>
          <tr>
            <td>High Deceleration counts</td>
            <td className="l-c">{fixDecimals(playerData.metrics.deccelFast, 0)}</td>
          </tr>
        </>
      )}
      </tbody>
    </Table>;
  }
};

export default DataPerformanceTab;